export const addCategories = (payload) => ({
    type: "ADD_CATEGORIES",
    payload
})